import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { BaseLoginService } from '../../../../../coverpath-common/angular/services/login/base-login.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private loginService: BaseLoginService ) { }

    canActivate() {
        const isLoggedIn = this.loginService.isLoggedIn();
        if (!isLoggedIn) {
            this.router.navigate(['login']);
        }
        return isLoggedIn;
    }
}